import React, { useState, useEffect, useRef } from 'react';
import "./Right.scss";
import Filter from './Filter';
import DataResult from './DataResult';
import { fetchCaractPromises, fetchData } from './ApiFetch';
import { fetchSearchData } from './ApiFetchSearch';

export default function Right({ apiData, apiDataCaract, minLvl, maxLvl, setMinLvl,setMaxLvl, onItemSelected, onHatSelected, onAmuSelected, onCloakSelected, onSwordSelected,onAnno2Selected,onBeltSelected,onBootsSelected, annoImage}) {
  const [searchItemId, setSearchItemId] = useState(null);
  const [, setSearchItemData] = useState([]);
  const [searchedItem, setSearchedItem] = useState(null);
  const searchItemIdRef = useRef(null);
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const searchInputRef = useRef();

  const handleSearch = () => {
    if (searchItemId) {
      fetchSearchData(searchItemId)
        .then(itemIds => fetchCaractPromises(itemIds))
        .then(data => {
          setSearchItemData(data);
          // const searchedItem = data.find(item => item.ankama_id);
          setSearchedItem(data);
          setIsSearchPerformed(true);
          data.forEach(item => console.log("ici",item));
        })
        .catch(error => {
          console.error("Erreur lors de la récupération des données de recherche :", error);
        });
    } else {
      setSearchItemData([]);
      setSearchedItem(null);
    }
  };

  const handleResetSearch = () => {
    setSearchItemId(null);
    setSearchItemData([]);
    setSearchedItem(null);
    setIsSearchPerformed(false);
    searchItemIdRef.current = null;
    if (searchInputRef.current) {
      searchInputRef.current.value = '';
    }
  };
  const handleMinLvlChange = (event) => {
    const value = event.target.value;
    setMinLvl(value);
  };
  const handleMaxLvlChange = (event) => {
    const value = event.target.value;
    setMaxLvl(value);
  };
  const handleFilterChange = async () => {
    await fetchData(apiData, apiDataCaract, parseInt(minLvl), parseInt(maxLvl));
  };

  useEffect(() => {
    if (searchItemId !== searchItemIdRef.current) {
      searchItemIdRef.current = searchItemId;
    }
  }, [searchItemId]);

  return (
    <div className='right__wrapper'>
      <Filter 
        onChange={handleSearch}
        setSearchItemId={setSearchItemId}
        searchInputRef={searchInputRef}
        onFilterChange={handleFilterChange}
        minLvl={minLvl}
        handleMinLvlChange={handleMinLvlChange}
        maxLvl={maxLvl}
        handleMaxLvlChange={handleMaxLvlChange}
      />
      {isSearchPerformed && (
      <button className='resetSearch' onClick={handleResetSearch}>Reset Search</button>
    )}
      <DataResult 
      apiData={apiData} 
      apiDataCaract={apiDataCaract} 
      searchedItem={searchedItem} 
      onItemSelected={onItemSelected}
      onHatSelected={onHatSelected}
      onAmuSelected={onAmuSelected}
      onCloakSelected={onCloakSelected} 
      onSwordSelected={onSwordSelected} 
      onAnno2Selected={onAnno2Selected} 
      onBeltSelected={onBeltSelected} 
      onBootsSelected={onBootsSelected} 
      annoImage={annoImage}
      />
    </div>
  );
}
